export default function removeToken() {
  localStorage.removeItem("token"); // 或者 cookie.remove('token')
}
